import AsianFooter from "app/screens/AsianEventsScreen/components/AsianFooter/AsianFooter";
import React from "react";
import RenderEndOfList from "../RenderEndOfList/RenderEndOfList";
export default function CompetitionsScreenListBottomSpacer(
  props: Record<string, any>
) {
  return (
    <React.Fragment>
      <div className="competitions-screen__list__bottom-spacer" />
      {props.competitionList.length > 0 && (
        <div>
          <RenderEndOfList
            fullListLoaded={props.fullListLoaded}
            competitionList={props.competitionList}
          />
        </div>
      )}
      <AsianFooter />
    </React.Fragment>
  );
}
